var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-card"},[_c('img',{staticClass:"top-cover",attrs:{"src":_vm.cardData.cover_url,"alt":""}}),_c('div',{staticClass:"top-msg"},[_c('div',{staticClass:"top-name ellipsis_two"},[_vm._v(_vm._s(_vm.cardData.name))]),_c('div',{staticClass:"top-num"},[_vm._v(_vm._s(_vm.cardData.category_name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }